<!-- MatchTable.svelte -->
<script>
  export let activeGroup;
  export let activeGame;
  export let matches;
  export let matchesOld;
  // export let toggleCell;
  export let toggleColumn;
  export let buttonsCouponInfo;
  export let infoCount;
  export let formatCouponValueColor;
  export let v1;
  export let vX;
  export let v2;
  export let formatDateTime;
  export let elapsedTime;
  export let handleTouchStart;
  export let handleTouchMove;
  export let handleTouchEnd;
  export let handleMouseDown
  export let handleMouseMove;
  export let handleMouseUp;
  export let handleMouseLeave;

</script>

{#if activeGame === undefined }
  Ingen aktiv omgång

{:else}    
<div class="matchTable">
<table>
  <thead>
    <tr>
      <th></th>
      <th style="text-align: left;">Match</th>
      <th>&nbsp;</th>
      <th on:click={() => toggleColumn(2)} class="gr{activeGroup}-hover">1</th>
      <th on:click={() => toggleColumn(3)} class="gr{activeGroup}-hover">X</th>
      <th on:click={() => toggleColumn(4)} class="gr{activeGroup}-hover">2</th>
    </tr>
  </thead>
  <tbody>
    {#each $matches as {
        Nr,
        Match, 
        Start,
        SvF_1, SvF_X, SvF_2, 
        odds_1, odds_X, odds_2,
        odds_1_fix, odds_X_fix, odds_2_fix,
        odds_1_diff, odds_X_diff, odds_2_diff
      }, rowIndex}
      <tr>
        <td style="text-align: right;">{Nr}</td>
        <td>{Match}<br /><small>{formatDateTime(Start)}</small></td>

        <td class="symbols info{infoCount}">
            {#if buttonsCouponInfo[0].active === true} 
              <p><img src="/images/{buttonsCouponInfo[0].img}" title="{buttonsCouponInfo[0].name}" alt="{buttonsCouponInfo[0].name}" height="12pt" /></p>
            {/if}
            {#if buttonsCouponInfo[1].active === true}
              <p><img src="/images/{buttonsCouponInfo[1].img}" title="{buttonsCouponInfo[1].name}" alt="{buttonsCouponInfo[1].name}" height="12pt" /></p>
            {/if}
            {#if buttonsCouponInfo[2].active === true} 
              <p><img src="/images/{buttonsCouponInfo[2].img}" title="{buttonsCouponInfo[2].name}" alt="{buttonsCouponInfo[2].name}" height="12pt" /></p> 
            {/if}
            {#if buttonsCouponInfo[3].active === true} 
              <p><img src="/images/{buttonsCouponInfo[3].img}" title="{buttonsCouponInfo[3].name}" alt="{buttonsCouponInfo[3].name}" height="12pt" /></p>
            {/if}
            {#if buttonsCouponInfo[4].active === true} 
              <p><img src="/images/{buttonsCouponInfo[4].img}" title="{buttonsCouponInfo[4].name}" alt="{buttonsCouponInfo[4].name}" height="12pt" /></p> 
            {/if}
        </td>

        <td
          on:mousedown={(event) => handleMouseDown(rowIndex, 2, event)}
          on:mousemove={(event) => handleMouseMove(event)}
          on:mouseup={handleMouseUp(rowIndex, 2)}
          on:mouseleave={handleMouseLeave}
          on:touchstart={(event) => handleTouchStart(rowIndex, 2, event)}
          on:touchmove={(event) => handleTouchMove(event)}
          on:touchend={handleTouchEnd(rowIndex, 2)}
          class="gr{v1[rowIndex]} info{infoCount} gr{activeGroup}-hover">

            {#if buttonsCouponInfo[0].active === true} 
              <p> {parseInt(SvF_1 * 100)}%</p>
            {/if}

            {#if buttonsCouponInfo[1].active === true}
              {#if odds_1 === undefined}
                <p>{NaN}</p>
              {:else}
                <p>
                  {#if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) !== parseFloat(odds_1.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) > parseFloat(odds_1.replace(',', '.'))}
                      <img src="/images/oddsDecrease.svg" title="Odds Decrease" alt="Odds Decrease" height="8pt" />
                    {:else if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) < parseFloat(odds_1.replace(',', '.'))}
                      <img src="/images/oddsIncrease.svg" title="Odds Increase" alt="Odds Increase" height="8pt" />
                    {/if}
                  {/if}
                  {odds_1}
                  {#if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) !== parseFloat(odds_1.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) > parseFloat(odds_1.replace(',', '.'))}
                      <br /><small>(-{(parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) - parseFloat(odds_1.replace(',', '.'))).toFixed(2)})</small>
                    {:else if parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.')) < parseFloat(odds_1.replace(',', '.'))}
                      <br /><small>(+{(parseFloat(odds_1.replace(',', '.')) - parseFloat($matchesOld[rowIndex].odds_1.replace(',', '.'))).toFixed(2)})</small>
                    {/if}
                  {/if}
                </p>
              {/if}
            {/if}

            {#if buttonsCouponInfo[2].active === true} 
              <p>{parseInt(odds_1_fix * 100)}%</p> 
            {/if}

            {#if buttonsCouponInfo[3].active === true} 
              {#if odds_1_diff === undefined}
                <p>{NaN}</p>
              {:else if odds_1_diff > 0} <p>+{odds_1_diff}</p>
              {:else} <p>{odds_1_diff}</p>
              {/if}
            {/if}

            {#if buttonsCouponInfo[4].active === true} 
              <p class={formatCouponValueColor((odds_1_fix / SvF_1).toFixed(2))}>{(odds_1_fix / SvF_1).toFixed(2)}</p> 
            {/if}

        </td>

        <td 
          on:mousedown={(event) => handleMouseDown(rowIndex, 3, event)}
          on:mousemove={(event) => handleMouseMove(event)}
          on:mouseup={handleMouseUp(rowIndex, 3)}
          on:mouseleave={handleMouseLeave}
          on:touchstart={(event) => handleTouchStart(rowIndex, 3, event)}
          on:touchmove={(event) => handleTouchMove(event)}
          on:touchend={handleTouchEnd(rowIndex, 3)}
          class="gr{vX[rowIndex]} info{infoCount} gr{activeGroup}-hover">
            {#if buttonsCouponInfo[0].active === true} 
              <p>{parseInt(SvF_X * 100)}%</p>
            {/if}
            {#if buttonsCouponInfo[1].active === true}
              {#if odds_X === undefined}
                <p>{NaN}</p>
              {:else}
                <p>
                  {#if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) !== parseFloat(odds_X.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) > parseFloat(odds_X.replace(',', '.'))}
                      <img src="/images/oddsDecrease.svg" title="Odds Decrease" alt="Odds Decrease" height="8pt" />
                   {:else if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) < parseFloat(odds_X.replace(',', '.'))}
                      <img src="/images/oddsIncrease.svg" title="Odds Increase" alt="Odds Increase" height="8pt" />
                    {/if}
                  {/if}
                  {odds_X}
                  {#if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) !== parseFloat(odds_X.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) > parseFloat(odds_X.replace(',', '.'))}
                      <br /><small>(-{(parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) - parseFloat(odds_X.replace(',', '.'))).toFixed(2)})</small>
                    {:else if parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.')) < parseFloat(odds_X.replace(',', '.'))}
                      <br /><small>(+{(parseFloat(odds_X.replace(',', '.')) - parseFloat($matchesOld[rowIndex].odds_X.replace(',', '.'))).toFixed(2)})</small>
                    {/if}
                  {/if}
                </p>
              {/if}
            {/if}
            {#if buttonsCouponInfo[2].active === true} 
              <p>{parseInt(odds_X_fix * 100)}%</p> 
            {/if}
            {#if buttonsCouponInfo[3].active === true} 
              {#if odds_X_diff === undefined}
                <p>{NaN}</p>
              {:else if odds_X_diff > 0} <p>+{odds_X_diff}</p>
              {:else} <p>{odds_X_diff}</p>
              {/if}
            {/if}
            {#if buttonsCouponInfo[4].active === true} 
              <p class={formatCouponValueColor((odds_X_fix / SvF_X).toFixed(2))}>{(odds_X_fix / SvF_X).toFixed(2)}</p> 
            {/if}
        </td>

        <td
          on:mousedown={(event) => handleMouseDown(rowIndex, 4, event)}
          on:mousemove={(event) => handleMouseMove(event)}
          on:mouseup={handleMouseUp(rowIndex, 4)}
          on:mouseleave={handleMouseLeave}
          on:touchstart={(event) => handleTouchStart(rowIndex, 4, event)}
          on:touchmove={(event) => handleTouchMove(event)}
          on:touchend={handleTouchEnd(rowIndex, 4)}
          class="gr{v2[rowIndex]} info{infoCount} gr{activeGroup}-hover">
            {#if buttonsCouponInfo[0].active === true} 
              <p>{parseInt(SvF_2 * 100)}%</p>
            {/if}
            {#if buttonsCouponInfo[1].active === true}
              {#if odds_2 === undefined}
                <p>{NaN}</p>
              {:else}
                <p>
                  {#if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) !== parseFloat(odds_2.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) > parseFloat(odds_2.replace(',', '.'))}
                      <img src="/images/oddsDecrease.svg" title="Odds Decrease" alt="Odds Decrease" height="8pt" />
                    {:else if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) < parseFloat(odds_2.replace(',', '.'))}
                      <img src="/images/oddsIncrease.svg" title="Odds Increase" alt="Odds Increase" height="8pt" />
                    {/if}
                  {/if}
                  {odds_2}
                  {#if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) !== parseFloat(odds_2.replace(',', '.'))}
                    {#if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) > parseFloat(odds_2.replace(',', '.'))}
                      <br /><small>(-{(parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) - parseFloat(odds_2.replace(',', '.'))).toFixed(2)})</small>
                    {:else if parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.')) < parseFloat(odds_2.replace(',', '.'))}
                      <br /><small>(+{(parseFloat(odds_2.replace(',', '.')) - parseFloat($matchesOld[rowIndex].odds_2.replace(',', '.'))).toFixed(2)})</small>
                    {/if}
                  {/if}
                </p>
              {/if}
            {/if}
            {#if buttonsCouponInfo[2].active === true} 
              <p>{parseInt(odds_2_fix * 100)}%</p> 
            {/if}
            {#if buttonsCouponInfo[3].active === true} 
              {#if odds_2_diff === undefined}
                <p>{NaN}</p>
              {:else if odds_2_diff > 0} <p>+{odds_2_diff}</p>
              {:else} <p>{odds_2_diff}</p>
              {/if}
            {/if}
            {#if buttonsCouponInfo[4].active === true}
              <p class={formatCouponValueColor((odds_2_fix / SvF_2).toFixed(2))}>{(odds_2_fix / SvF_2).toFixed(2)}</p> 
            {/if}
        </td>

      </tr>     
    {/each}
  </tbody>
</table>
<div class="elapsedTime">{elapsedTime}</div>
</div>
{/if}


<style>
  /* Table styles */

table {
/*   border-radius: 10pt 10pt 10pt 10pt; */
  width: 100%;
/*    min-width: 500px; */
  font-size: 12pt;
  border-spacing:0;
  padding: 0 2pt 0 2pt;
/*   overflow-y: auto; */
/*   -webkit-overflow-scrolling: touch; */
/*   margin-bottom: 20pt; */
  -webkit-user-select: none;
  user-select: none;
}

.elapsedTime {
  color: var(--themeColorText);
  min-width: 100%;
  font-size: 10pt;
  font-weight: 300;
/*   border: 1pt solid red; */
  text-align: center;
  margin-top: 3pt;
  margin-left: auto;
  margin-right: auto;
}

thead {
  position: sticky;
  top: 0;
}

th {
/*   position: sticky;
  top: 0; */
/*   background-color: #ddd; */
/*   border-bottom: 2px solid rgb(214, 214, 214); */
  background-color: var(--themeColor1);
/*   border-bottom: 2px solid var(--themeColor1); */
  color: var(--themeColorText);
}

tr:first-child td:first-child {
  border-radius: 10pt 0 0 0;
}

tr:first-child td:last-child {
  border-radius: 0 10pt 0 0;
}

tr:last-child td:first-child {
  border-radius: 0 0 0 10pt;
}

tr:last-child td:last-child {
  border-radius: 0 0 10pt 0;
}

tr:last-child td {
  border-bottom: none;
}

td {
  background-color: #F5F5F5;
  padding: 3px 5px 3px 5px;
  line-height: 1;
/*   border-bottom: 2px solid rgb(214, 214, 214); */
  border-bottom: 2px solid var(--themeColor1);
/*   background: rgba(var(--themeColor1), 0.4); */
}

td small {
  font-size: 10pt;
}  

td p {
  padding: 0;
  margin: 3pt;
  transition: opacity 0.3s ease-in-out;
/*   -webkit-user-select: none;
  user-select: none; */
}

td p small {
  font-size: 8pt;
}

td.symbols {
  text-align: center;
  padding: 0;
  margin: 0;
}

td.symbols img {
  filter: opacity(25%);
}

td.gr0, td.gr1, td.gr2, td.gr3, td.gr4, td.gr5 {
  text-align: center;
  cursor: pointer;
  min-width: 55px;
}

td.gr1, td.gr2, td.gr3, td.gr4, td.gr5 {
  border-radius: 0px;
}

td.info1 {
  font-size: 12pt;
  transition: font-size 0.3s ease;
}

td.info2 {
  font-size: 10pt;
  transition: font-size 0.3s ease;
}

td.info3 {
  font-size: 10pt;
  transition: font-size 0.3s ease;
}

td.info4 {
  font-size: 9pt;
  transition: font-size 0.3s ease;
}

td.info5 {
  font-size: 9pt;
  transition: font-size 0.3s ease;
}

tr:hover {
  background-color: #e9e9e9;
}

.couponValue1, .couponValue2, .couponValue3, .couponValue4, .couponValue5 {
/*   border: 1px solid red;
  text-decoration: line-through;
  text-decoration-style: solid;
  text-decoration-thickness: 12pt; */
/*   height: 11pt; */
/*   line-height: calc(100% - 400px); */
/*   margin-top: -3pt; */
  border-radius: 10pt 10pt 10pt 10pt;
  border: 2pt solid;
}

.couponValue1 {
/*   text-decoration-color: orange; */
  background-color: red;
  border-color: red;
  color: white;
}

.couponValue2 {
/*   text-decoration-color: orange; */
  background-color: orange;
  border-color: orange;
  color: black;
}

.couponValue3 {
/*   text-decoration-color: yellow; */
  background-color: yellow;
  border-color: yellow;
  color: black;
}

.couponValue4 {
/*   text-decoration-color: lightgreen; */
  background-color: lightgreen;
  border-color: lightgreen;
  color: black;
}

.couponValue5 {
/*   text-decoration-color: green; */
  background-color: green;
  border-color: green;
  color: white;
}

@media (hover: hover) {

  th.gr0-hover:hover, th.gr1-hover:hover {
    border-bottom: none;
    background-color: rgba(30, 144, 255, 1);
/*     border-radius: 10pt 10pt 0 0; */
  }

  th.gr2-hover:hover, th.gr3-hover:hover, th.gr4-hover:hover, th.gr5-hover:hover {
    border-bottom: none;
    background-color: var(--themeColor1);
  }

  tr:last-child td.gr0-hover:hover, tr:last-child td.gr1-hover:hover, tr:last-child td.gr2-hover:hover, tr:last-child td.gr3-hover:hover, tr:last-child td.gr4-hover:hover, tr:last-child td.gr5-hover:hover {
    border-bottom: none;
  }

  .gr0-hover:hover, .gr1-hover:hover {
    border-bottom: 2px solid rgba(30, 144, 255, 1);
    background-color: rgba(30, 144, 255, 0.4);
    transition: background-color 0.3s ease-in-out;
/*     border-radius: 10pt; */
  }
  .gr2-hover:hover {
    border-bottom: 2px solid rgba(255, 215, 0, 1);
    background: rgba(255, 215, 0, 0.4);
    transition: background-color 0.3s ease-in-out;
  }
  .gr3-hover:hover {
    border-bottom: 2px solid rgba(255, 69, 0, 1);
    background: rgba(255, 69, 0, 0.4);
    transition: background-color 0.3s ease-in-out;
  }
  .gr4-hover:hover {
    border-bottom: 2px solid rgba(50, 205, 50, 1);
    background: rgba(50, 205, 50, 0.4);
    transition: background-color 0.3s ease-in-out;
  }
  .gr5-hover:hover {
    border-bottom: 2px solid rgba(255, 105, 180, 1);
    background: rgba(255, 105, 180, 0.4);
    transition: background-color 0.3s ease-in-out;
  }

}

/* Responsive adjustments for mobile screens */
@media (max-width: 768px) {
  table {
    font-size: 12pt;
  }

  td.gr0, td.gr1, td.gr2, td.gr3, td.gr4, td.gr5 {
  text-align: center;
  }

  td.info1 {
  font-size: 12pt;
  transition: font-size 0.3s ease;
  }

  td.info2 {
    font-size: 10pt;
    transition: font-size 0.3s ease;
  }

  td.info3 {
    font-size: 10pt;
    transition: font-size 0.3s ease;
  }

  td.info4 {
    font-size: 9pt;
    transition: font-size 0.3s ease;
  }

  td.info5 {
    font-size: 8pt;
    transition: font-size 0.3s ease;
  }

}

</style>